var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from 'react';
import { BaseInput } from './Input';
export var ColorPicker = function (_a) {
    var id = _a.id, name = _a.name, value = _a.value, onChange = _a.onChange, error = _a.error, label = _a.label, props = __rest(_a, ["id", "name", "value", "onChange", "error", "label"]);
    var _b = useState(value), hexValue = _b[0], setHexValue = _b[1];
    var _c = useState(1), alphaValue = _c[0], setAlphaValue = _c[1];
    var _d = useState(false), isOpen = _d[0], setIsOpen = _d[1];
    var colorPickerRef = useRef(null);
    var containerRef = useRef(null);
    var handleColorChange = function (e) {
        var newValue = e.target.value;
        setHexValue(newValue);
        onChange(e);
    };
    var handleAlphaChange = function (e) {
        var newValue = parseFloat(e.target.value);
        setAlphaValue(newValue);
        // Get hex value of alpha value
        var alphaHex = Math.round(newValue * 255)
            .toString(16)
            .padStart(2, '0');
        setHexValue(function (prevValue) {
            var hexValue = prevValue.slice(0, 7);
            return "".concat(hexValue).concat(alphaHex);
        });
        // Update the color value with the new alpha value in hex format
        onChange({
            target: { name: name, value: "".concat(hexValue.slice(0, 7)).concat(alphaHex) },
        });
    };
    var handleOnColorPickerClick = function () {
        if (colorPickerRef.current) {
            colorPickerRef.current.click();
            setIsOpen(true);
        }
    };
    // Close dropdown when clicking outside
    useEffect(function () {
        var handleClickOutside = function (event) {
            if (containerRef.current && !containerRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return function () {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
    useEffect(function () {
        setHexValue(value);
    }, [value]);
    return (_jsxs("div", { ref: containerRef, className: 'vas-relative vas-flex vas-gap-1 vas-flex-col vas-w-full vas-h-full vas-min-h-16', children: [label && (_jsx("label", { htmlFor: id, className: 'vas-block vas-text-sm vas-font-medium vas-text-vastypographyLabelsTextColor', children: label })), _jsxs("div", { className: "\n          vas-flex vas-items-center vas-h-full vas-border vas-rounded-md vas-transition-all vas-duration-200 vas-ease-in-out\n          ".concat(error ? 'vas-border-vasDanger' : 'vas-border-gray-300', "\n          ").concat(isOpen ? 'vas-ring-2 vas-ring-primary' : 'hover:vas-border-gray-400', "\n        "), onClick: handleOnColorPickerClick, children: [_jsx("div", { className: 'vas-min-w-8 vas-h-full vas-rounded-l-md vas-border-r', style: {
                            backgroundColor: hexValue,
                            borderColor: error ? '#EF4444' : 'inherit',
                        } }), _jsx(BaseInput, __assign({ ref: colorPickerRef, type: 'color', id: id, name: name, hasError: !!error, value: hexValue, className: 'vas-absolute vas-opacity-0 vas-w-0 vas-h-0', onChange: handleColorChange }, props)), _jsxs("div", { className: 'vas-flex vas-px-1 vas-py-2 vas-w-full vas-flex-col', children: [_jsx("input", { type: 'text', readOnly: true, value: hexValue === null || hexValue === void 0 ? void 0 : hexValue.toUpperCase(), className: '\n              vas-w-full vas-bg-transparent\n              vas-h-full\n              vas-text-vastypographyLabelsTextColor vas-text-sm \n              focus:vas-outline-none vas-cursor-pointer\n            ', "aria-label": 'Color Value', role: 'button', tabIndex: 0, onClick: handleOnColorPickerClick }), _jsx("input", { type: 'range', min: '0', max: '1', step: '0.1', className: 'vas-w-20', value: alphaValue, onChange: handleAlphaChange, "aria-label": 'Alpha Value' })] }), _jsx("button", { type: 'button', onClick: handleOnColorPickerClick, className: '\n            vas-px-3 vas-py-2 vas-bg-gray-50 vas-h-full vas-border-l \n            hover:vas-bg-secondary focus:vas-outline-none\n            vas-transition-colors vas-duration-200\n          ', "aria-label": 'Open Color Picker', children: _jsx("svg", { xmlns: 'http://www.w3.org/2000/svg', className: 'vas-w-5 vas-h-5 vas-text-gray-600', fill: 'none', viewBox: '0 0 24 24', stroke: 'currentColor', children: _jsx("path", { strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: 2, d: 'M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zm0 0h12a2 2 0 002-2v-4a2 2 0 00-2-2h-2.343M11 7.343l1.657-1.657a2 2 0 012.828 0l2.829 2.829a2 2 0 010 2.828l-8.486 8.485M7 17h.01' }) }) })] }), error && typeof error === 'string' && (_jsx("p", { className: 'vas-mt-1 vas-text-sm vas-text-vasDanger', children: error }))] }));
};
